import React from 'react';
import { PLANS } from '../config/billing';
import '../components/layout/DashboardLayout.css';

const freeTrial = PLANS.find((p) => p.id === 'trial') ?? PLANS[0];

/** Placeholder until paid plans and payment addresses ship. Full UI kept in BillingPage. */
const BillingPageDisabled: React.FC = () => {
  return (
    <div>
      <div className="dash-page-header">
        <h2>Billing</h2>
        <p>Your current plan.</p>
      </div>

      <div className="dash-card">
        <h3>Subscription</h3>
        <div className="dash-plan-options" role="list" aria-label="Plan">
          <div className="dash-plan-option selected" role="listitem">
            <strong>{freeTrial.name}</strong>
            <span>{freeTrial.description}</span>
            <span className="dash-badge dash-badge-accent">Current</span>
          </div>
          <div className="dash-plan-option dash-plan-option-soon" role="listitem" aria-disabled="true">
            <strong>More options soon…</strong>
            <span>Paid plans and USDC billing are on the way.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingPageDisabled;
